// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19SaC","question":"styles_question__3FeAF","description":"styles_description__2vJmT"};